import React from "react";

const LittleCircle = () => {
    return (
        <div className='little-circle' />
    )
}

export default LittleCircle